function projectId(project) {
  return project && project._id != null ? String(project._id) : "";
}

export function preferredProjectId({
  projects = [],
  currentId = null,
  storedId = null,
  preferTagger = false,
} = {}) {
  if (!Array.isArray(projects) || projects.length === 0) return null;

  const current = projects.find(project => projectId(project) === String(currentId || ""));
  if (current) return current._id;

  const stored = projects.find(project => projectId(project) === String(storedId || ""));
  if (stored) return stored._id;

  if (preferTagger) {
    const tagger = projects.find(project => String(project.name || "").toLowerCase() === "tagger");
    if (tagger) return tagger._id;
  }

  return projects[0]._id;
}
